/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SliderExperience from '@ieo/Components/SliderExperience';
import { usePageConfigValue } from '@ieo/hooks/usePageConfigVal';

/* Services */
/* Styles */

/**
 *
 * @param {Object} SectionContent
 * @param {String} lang
 * @param {String} region
 * @returns ProgramTestimonial
 */
const ProgramTestimonial = ({
  sectionContent,
  region,
  lang,
  pageData,
  prgData,
}) => {
  const currentCoupon = Object.values(prgData)[0]?.coupon;

  const { pageConfigVal, isThemeActive } = usePageConfigValue(
    pageData,
    region,
    currentCoupon
  );

  return (
    <Box
      bg={{
        base:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.myExp?.bgImage?.mob}) #F1EBDF`
            : `#F1EBDF`,
        md:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.myExp?.bgImage?.tab}) #F1EBDF`
            : `#F1EBDF`,
        lg:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.myExp?.bgImage?.bigScreen}) #F1EBDF`
            : `#F1EBDF`,
        xl:
          isThemeActive && pageConfigVal
            ? `url(${pageConfigVal?.myExp?.bgImage?.bigScreen}) #F1EBDF`
            : `#F1EBDF`,
      }}
      bgRepeat={
        pageConfigVal?.myExp?.bgImage?.repeat === true
          ? 'repeat-x'
          : 'no-repeat'
      }
      // bgPos={'bottom'}
      backgroundPosition={{
        base: '0% 6%!important',
        md: '0% 37%!important',
        lg: '0% 34%!important',
        xl: '0% 35%!important',
        '2xl': '0% 26%!important',
      }}
      // pb={{ base: '20px', md: '0' }}
    >
      <Flex
        maxW="1330px"
        flexDir="column"
        mb={{
          md: lang === 'es' ? '0px' : '40px',
          xl:
            region === 'us' || region === 'ca' || lang === 'es'
              ? '0px'
              : '90px',
        }}
        margin={'0 auto'}
      >
        <Box
          pos={{ base: 'static', md: 'relative' }}
          top="30px"
          // h={{ base: '640px', md: '500px', lg: '480px' }}
        >
          <SliderExperience
            sectionContent={sectionContent?.[0]}
            lang={lang}
            arrowTop="inherit"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default ProgramTestimonial;
